import { FC } from "react";
import { ViewProps } from "../types";
import { useMainLayout } from "../hooks/useMainLayout";

export const withData = (View: FC<ViewProps>) => (props: ViewProps) => {
  const headerContent = useMainLayout();

  return <View {...props} {...headerContent} />;
};
